import styled, { css } from 'styled-components'
import { colors } from 'modules/dashboard/Home/Dashboard.global.styles'
import { phoneMaxWidth, ipadPortraitMaxWidth } from '../../../../DashboardSettings.styles'

export const ContentWrapper = styled.div`
  display: flex;
  max-width: 830px;
  margin: auto;
  padding: 20px 0;

  @media (max-width: ${ipadPortraitMaxWidth}px) {
    padding: 20px 15px;
  };
`

export const MainTextWrapper = styled.div`
  width: 400px;
`

export const Title = styled.h1`
  display: flex;
  font-size: 24px;
  color: ${colors.pink};
  margin: 0 0 30px;
`

export const InfoSection = styled.div`
  display: flex;
  flex-direction: column;
  margin-left: 60px;
`

export const Info = styled.p`
  margin: 0 0 20px;
  color: ${colors.pink};
`
